import React, { useId } from 'react';

const VB = 64;
const CX = VB / 2;
const CY = VB / 2;

/**
 * Dataset mark: filled disc with three stacked-ellipse cutouts (cylinder silhouette),
 * leaving horizontal bands of ink between — negative space in the cylinder regions.
 */
export function BesperDatasetProductMarkGroup({ iconColor = '#022d54', accentColor }) {
  const uid = useId().replace(/:/g, '');
  const maskId = `besperDsMask-${uid}`;
  const stroke = accentColor || iconColor;

  return (
    <g>
      <defs>
        <mask id={maskId}>
          <circle cx={CX} cy={CY} r={25.5} fill="white" />
          <ellipse cx={CX} cy={19} rx={17} ry={5.5} fill="black" />
          <ellipse cx={CX} cy={CY} rx={17} ry={5.5} fill="black" />
          <ellipse cx={CX} cy={45} rx={17} ry={5.5} fill="black" />
        </mask>
      </defs>
      <circle cx={CX} cy={CY} r={25.5} fill={iconColor} mask={`url(#${maskId})`} />
      <ellipse cx={CX} cy={19} rx={17} ry={5.5} fill="none" stroke={stroke} strokeWidth={2} opacity={0.55} />
      <ellipse cx={CX} cy={CY} rx={17} ry={5.5} fill="none" stroke={stroke} strokeWidth={2} opacity={0.55} />
      <ellipse cx={CX} cy={45} rx={17} ry={5.5} fill="none" stroke={stroke} strokeWidth={2} opacity={0.55} />
      <circle cx={CX} cy={CY} r={27} fill="none" stroke={iconColor} strokeWidth={2} opacity={0.35} />
    </g>
  );
}

export function BesperDatasetProductMark({
  size = 64,
  className = '',
  iconColor = '#022d54',
  accentColor,
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${VB} ${VB}`}
      className={className}
      aria-hidden
    >
      <BesperDatasetProductMarkGroup iconColor={iconColor} accentColor={accentColor} />
    </svg>
  );
}
